module.exports = __webpack_public_path__ + "img/electron_icon.5fbf91db.png";